export default {
  windowWidth: 0,
  shallShowOverlay: false,
}
